import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const domain = createReducer({
  list: [],
  plans: [],
}, {
  [types.GET_DOMAINS_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      list: action.domains,
    });
    return newState;
  },
  [types.GET_PRICING_PLANS_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      plans: action.pricingplan,
    });
    return newState;
  },
  [types.GET_PRICING_PLANS_ERROR](state, action) {
    const newState = Object.assign({}, state, {
      plans: [],
    });
    return newState;
  },
});

export { domain as default };
